// eslint-disable-next-line import/no-cycle
import {
  WidgetTypeConfig,
  ConfigurationPanelStructureItemEnum,
  Property,
  TemplateStructureEnum,
  ElementPartTypeEnum,
  ComponentNameEnum,
} from '@/types';
// eslint-disable-next-line import/no-cycle
import {
  setAttribute,
  setContactProperty,
  setContent,
  toggleAttribute,
  toggleClass,
  toggleShowLabelInside,
} from '@/components/template-builder/setters';
// eslint-disable-next-line import/no-cycle
import {
  getAttributeByName,
  getContactProperty,
  getContentWithLineBreaks,
  hasAttribute,
  hasClass,
} from '@/components/template-builder/getters';
import variables from '@/components/template-builder/utils/variables-list';
// eslint-disable-next-line import/no-cycle
import getInputVariablesFieldConfig from '@/components/template-builder/config/fields/input-variables-config';
// eslint-disable-next-line import/no-cycle
import getDisplayFieldConfig from '@/components/template-builder/config/fields/display-config';
// eslint-disable-next-line import/no-cycle
import { getFormFieldContactPropertyConfig } from '@/components/template-builder/config/fields/form-fields-config';
// eslint-disable-next-line import/no-cycle
import getTriggerButtonFieldConfig from '@/components/template-builder/config/fields/trigger-button-config';
// eslint-disable-next-line import/no-cycle
import { toggleDesignPanel } from '@/components/template-builder/callbacks';
// eslint-disable-next-line import/no-cycle
import getWidgetCommonStylesGroup from '@/components/template-builder/config/fields/widget-common-styles-config';

const widgetInputEmailConfig: WidgetTypeConfig = {
  tabPanel: {
    label: 'templateBuilder.widgetsHeaders.inputEmail',
    items: [
      {
        type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
        label: 'templateBuilder.configs.widgetConfiguration',
        selector: 'body #spm_body #{ID}',
        items: [
          {
            label: 'templateBuilder.formFields.contactProperty',
            selector: '{SELECTOR}',
            properties: [{ name: 'contactProperty', getter: getContactProperty, setters: [setContactProperty] }],
            fieldId: 'contactProperty',
            ...getFormFieldContactPropertyConfig({ typeWidget: 'inputEmail' }),
          },
          {
            label: 'templateBuilder.formFields.showLabel',
            selector: '{SELECTOR} .spm_widget_input_email__container',
            properties: [
              {
                name: 'spm_label_inside',
                getter: (selector: string, name: string) => hasClass(selector, name, { revert: true }),
                setters: [
                  (selector: string, property: Property) => toggleClass(
                    selector,
                    property,
                    {
                      revert: true,
                      callback: () => toggleShowLabelInside(selector, property),
                    },
                  ),
                ],
              },
            ],
            fieldId: 'showLabelInside',
            ...getDisplayFieldConfig('spm_label_inside'),
            displayToggle: false,
          },
          {
            label: 'templateBuilder.formFields.label',
            selector: '{SELECTOR} .spm_widget_input_email__label',
            properties: [{ name: 'content', getter: getContentWithLineBreaks, setters: [setContent] }],
            fieldId: 'label',
            ...getInputVariablesFieldConfig('Email', variables.allVariables, false, true),
          },
          {
            label: 'templateBuilder.formFields.inputPlaceholder',
            selector: '{SELECTOR} .spm_widget_input_email__input',
            properties: [{ name: 'placeholder', getter: getAttributeByName, setters: [setAttribute] }],
            fieldId: 'placeholder',
            ...getInputVariablesFieldConfig('Email', variables.allVariables, false, true),
          },
          {
            label: 'templateBuilder.formFields.fieldRequired',
            selector: '{SELECTOR} .spm_widget_input_email__input',
            properties: [{ name: 'required', getter: hasAttribute, setters: [toggleAttribute] }],
            fieldId: 'fieldRequired',
            ...getDisplayFieldConfig('required'),
            displayToggle: false,
            allowEmpty: false,
          },
        ],
      },
      {
        type: ConfigurationPanelStructureItemEnum.TAB_ITEM,
        tabItemType: TemplateStructureEnum.GROUP,
        label: 'templateBuilder.configs.widgetStyles',
        canSave: true,
        elementPartType: ElementPartTypeEnum.STYLES,
        tabPanel: {
          items: [
            {
              type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
              label: 'templateBuilder.configs.widgetBlockStyles',
              selector: '',
              items: [
                {
                  label: 'templateBuilder.formFields.stylesInGlobalFormConfig',
                  selector: '',
                  properties: [],
                  componentName: ComponentNameEnum.INFORMATION,
                  options: {
                    severity: 'secondary',
                  },
                },
                {
                  label: 'templateBuilder.formFields.goToGlobalFormStyles',
                  selector: '',
                  properties: [],
                  ...getTriggerButtonFieldConfig(
                    'templateBuilder.formFields.goToGlobalFormStyles',
                    'templateBuilder.formFields.goToGlobalFormStyles',
                    () => toggleDesignPanel('pageInputs'),
                  ),
                },
              ],
            },
            getWidgetCommonStylesGroup(),
          ],
        },
      },
    ],
  },
};

export default widgetInputEmailConfig;
